var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOpenBookContent = function SvgOpenBookContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#999AA1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9 3.035a7.472 7.472 0 0 0-5-1.91c-.877 0-1.718.15-2.5.427v10.875A7.487 7.487 0 0 1 4 12c1.92 0 3.673.722 5 1.91M9 3.035a7.472 7.472 0 0 1 5-1.91c.877 0 1.718.15 2.5.427v10.875A7.487 7.487 0 0 0 14 12c-1.92 0-3.673.722-5 1.91M9 3.035V13.91"
  })));
};
export default SvgOpenBookContent;